import { render, staticRenderFns } from "./guidedTour.vue?vue&type=template&id=5364496e&scoped=true&"
import script from "./guidedTour.vue?vue&type=script&lang=js&"
export * from "./guidedTour.vue?vue&type=script&lang=js&"
import style0 from "./guidedTour.vue?vue&type=style&index=0&id=5364496e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5364496e",
  null
  
)

export default component.exports